import React from "react";
import { graphql, Link } from "gatsby";
import Layout from "../../layouts";
import SEO from "@herb/components/seo";
import { deployUrl } from "@herb/utils";
import DispensaryDealCard from "../../components/Cards/DispensaryDealCard";
import DealCategoryContents from "../../components/DealCategoryContents";
import "@herb/pages/deals/index.css";

const DealsCategory = ({ data, pageContext }) => {
  const { category, deals, dealsCategories, dealspage } = data;

  // Breadcrumbs for SEO
  const breadcrumbs = [
    { name: "Home", url: "/" },
    { name: "Deals", url: "/deals" },
    { name: category.name, url: `/deals/${pageContext.slug}` }
  ];

  return (
    <>
      <div className="dealsPageMain">
        <Layout page="dealsCategory">
          <SEO
            title={`${category.name} Deals - Herb`}
            description={`Find the best ${category.name} deals.`}
            url={`/deals/${pageContext.slug}`}
            canonical={`${deployUrl}/deals/${pageContext.slug}`}
            breadcrumbs={breadcrumbs}
          />
          <div className="deals-page-content">
            <DealCategoryContents
              categories={dealsCategories?.nodes || []}
              activeCategory={category}
              deals={deals?.nodes || []}
              sortedDeals={category?.dealCategoryContent?.sortedDeals || []}
              allDealsCategoryImage={
                dealspage?.dealCategoryContent?.categoryImage
              }
            />
          </div>
        </Layout>
      </div>
    </>
  );
};

export default DealsCategory;

export const pageQuery = graphql`
  query($id: String!) {
    category: wordpressWpDealCategory(id: { eq: $id }) {
      id
      name
      slug
      dealCategoryContent {
        banner {
          mainBannerImage {
            sourceUrl
            altText
          }
          mobileBannerImage {
            sourceUrl
            altText
          }
          link
        }
        categoryImage {
          sourceUrl
          altText
        }
        noDeals
        sortedDeals {
          ... on WordpressWpDeal {
            id
            title
            featuredImage {
              node {
                altText
                sourceUrl
              }
            }
            contentMobileImage {
              mobileImage {
                altText
                sourceUrl
              }
            }
            contentDeals {
              contentDeals {
                product {
                  ... on WordpressWpProduct {
                    id
                    contentProducts {
                      productImages {
                        title
                        sourceUrl
                      }
                    }
                    title
                    brand_name
                  }
                }
                customTitle
                badgeText
                badgeColor
                badgeBackgroundColor
                dealLink
                ctaLabel
                ctaColor
                ctaBackgroundColor
                dealOffer
                dealOfferColor
              }
            }
          }
        }
        categorySubtext
        categorySubtext2
        faqs {
          heading
          description
          qas {
            question
            answer
          }
        }
        details {
          heading
          description1
          description2
        }
      }
    }
    dealsCategories: allWordpressWpDealCategory {
      nodes {
        id
        slug
        name
        databaseId
        dealCategoryContent {
          categoryImage {
            sourceUrl
            altText
          }
        }
      }
    }
    deals: allWordpressWpDeal(
      filter: { dealsCategories: { nodes: { elemMatch: { id: { eq: $id } } } } }
    ) {
      nodes {
        id
        title
        featuredImage {
          node {
            altText
            sourceUrl
          }
        }
        contentMobileImage {
          mobileImage {
            altText
            sourceUrl
          }
        }
        contentDeals {
          contentDeals {
            product {
              ... on WordpressWpProduct {
                id
                contentProducts {
                  productImages {
                    title
                    sourceUrl
                  }
                }
                title
                brand_name
              }
            }
            customTitle
            badgeText
            badgeColor
            badgeBackgroundColor
            dealLink
            ctaLabel
            ctaColor
            ctaBackgroundColor
            dealOffer
            dealOfferColor
          }
        }
      }
    }
    dealspage: wordpressWpPage(slug: { eq: "deals" }) {
      dealCategoryContent {
        categoryImage {
          sourceUrl
          altText
        }
      }
    }
  }
`;
